import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { default as AuthContext } from './auth-context';
import request, { client } from "./utils/axios";

const AuthCtx = props => {
  const storage = process.env.REACT_APP_BC4T_DEV === 'true' ? sessionStorage : localStorage

  const [authState, setAuth] = useState({
    profile: JSON.parse(storage.getItem("profile")),
    access_token: storage.getItem("access_token"),
    expires_at: storage.getItem("expires_at")
  });

  const isAuthenticated = () => {
    if (authState.expires_at === null || authState.expires_at === 'null') {
      return false
    }

    let expiresAt = moment(authState.expires_at).toDate();
    return new Date().getTime() < expiresAt.getTime();
  }

  const authenticate = (token) => {
    return request({ method: "post", url: `/authenticate`, data: { token: token } }, false).then((response) => {
      setSession(response);
    }).catch((error) => {
      console.log(error)
      return Promise.reject('Unauthorized');
    })
  }

  const setSession = (authResult) => {
    if (authResult === null) return clearSession()
    setAuth({ ...authState, access_token: authResult.access_token, expires_at: authResult.expires_at, profile: authResult.profile})
    localStorage.setItem("access_token", authResult.access_token);
    localStorage.setItem("expires_at", authResult.expires_at);
    localStorage.setItem("profile", JSON.stringify(authResult.profile));
  }

  const clearSession = () => {
    if (window.tokenRenewalTimeout) clearTimeout(window.tokenRenewalTimeout)
    window.tokenRenewalTimeout = null
    setAuth({ ...authState, access_token: null, expires_at: null, profile: null })
    localStorage.setItem("access_token", null);
    localStorage.setItem("expires_at", null);
    localStorage.setItem("profile", null);
  }

  const logout = () => {
    clearSession()
  }

  const hasRole = (role) => authState.profile && authState.profile.roles && authState.profile.roles.includes(role)
  const anyRoles = (roles) => authState.profile && authState.profile.roles && roles.some(r => authState.profile.roles.includes(r))

  const scheduleRenewal = () => {
    if (!isAuthenticated()) return

    let expiresAt = moment(authState.expires_at).subtract(5, 'minute').toDate();
    let delay = expiresAt.getTime() - new Date().getTime();
    if (delay > 0) {
      if (window.tokenRenewalTimeout) clearTimeout(window.tokenRenewalTimeout)
      window.tokenRenewalTimeout = setTimeout(() => {
        if (authState.profile === null) return
        client({ method: "post", url: `/refresh_token` })
          .then((response) => {
            setSession(response.data);
            scheduleRenewal();
          })
          .catch((error) => {
            console.log(error);
          });
      }, 60 * 1000 * 10) // 10 minutes
    }
  }

  useEffect(() => {
    scheduleRenewal()
  }, [authState.expires_at])


  return (
    <AuthContext.Provider
      value={{
        state: authState,
        profile: authState.profile,
        hasRole: hasRole,
        isAuthenticated: isAuthenticated,
        authenticate: authenticate,
        setSession: setSession,
        clearSession: clearSession,
        logout: logout,
        scheduleRenewal: scheduleRenewal,
        anyRoles: anyRoles
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthCtx
